import { ContactSummary } from 'components/contacts/contact_summary'
import type { ContactSummaryProps } from 'components/contacts/contact_summary'
import React, { useMemo } from 'react'
import { makeIsSpecificTeammateOnline } from 'reduxes/slices/handles/selectors'
import { useSelectorDelegateStore } from 'reduxes/stores/root_store/hooks'

import { css } from 'design'
import { cn } from 'util/cn'

export type CallContactSummaryProps = {
  participant: any
  isConnected?: boolean
} & Pick<ContactSummaryProps, 'variant'> &
  React.HTMLAttributes<HTMLDivElement>

export const CallContactSummary = ({
  participant,
  variant = 'list',
  isConnected,
  className,
  children,
}: React.PropsWithChildren<CallContactSummaryProps>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const presenceSelector: any = useMemo(makeIsSpecificTeammateOnline, [])

  const presence = useSelectorDelegateStore((state) =>
    presenceSelector(state, { handle: participant.handle }),
  )

  return (
    <ContactSummary
      participant={participant}
      variant={variant}
      presence={presence}
      className={cn(contactSummaryStyles({ isConnected }), className)}
    >
      {children}
    </ContactSummary>
  )
}

const contactSummaryStyles = css({
  variants: {
    isConnected: {
      true: {},
      false: {
        '*': {
          opacity: 0.6,
          filter: 'grayscale(1.0)',
        },
      },
    },
  },
  defaultVariants: {
    isConnected: 'false',
  },
})
